// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".business-rules-table-toolbar[data-v-5e5fd31d] {\n  padding-top: 23px;\n  justify-content: space-between;\n}\n", ""]);
// Exports
module.exports = exports;
